import type { CottagePage } from '../entities/CottagePage'
import type { MenuBreadcrumbItems } from '~/modules/menu/entities/MenuBreadcrumbItems'

const decoratorCottageToMenuBreadcrumb = (
  cottage: CottagePage,
): MenuBreadcrumbItems => {
  const breadcrumbMenu: MenuBreadcrumbItems = []

  breadcrumbMenu.push({
    href: routes().cottageList(),
    name: t('menu.breadcrumb.cottages'),
  })

  breadcrumbMenu.push({
    href: routes().cottageProvince({ slug: cottage.region.slug }),
    name: cottage.region.name,
  })

  if (cottage.region.slug !== cottage.province.slug) {
    breadcrumbMenu.push({
      href: routes().cottageProvince({ slug: cottage.province.slug }),
      name: cottage.province.name,
    })
  }

  breadcrumbMenu.push({
    href: routes().cottageProvince({ slug: cottage.village.slug }),
    name: cottage.village.name,
  })

  return breadcrumbMenu
}

export default decoratorCottageToMenuBreadcrumb
